
import React, { useState } from "react";
import {
  useNavigate,
  useSearchParams,
   useLocation
} from "react-router-dom";
import axios from "axios";

import styles from "./BookTestRewardSelector.module.css";

const TEST_PACKAGES = [
  {
    id: "1151",
    title: "SSC CGL Tier 1",
    name: "Rewarded SSC CGL Mock Test 2026 - 2027",
    description: "5 Full-Length Mock Tests",
  },
  {
    id: "1153",
    title: "SSC CHSL Tier 1",
    name: "Rewarded SSC CHSL Mock Test 2026 - 2027",
    description: "5 Full-Length Mock Tests",
  },
    {
    id: "1154",
    title: "SSC MTS Tier 1",
    name: "Rewarded SSC MTS Mock Test 2026 - 2027",
    description: "5 Full-Length Mock Tests",
  },
    {
    id: "1155",
    title: "SSC GD Tier 1 (English Medium)",
    name: "Rewarded SSC GD Mock Test 2026 - 2027 (English Medium)",
    description: "5 Full-Length Mock Tests",
  },
    {
    id: "1156",
    title: "SSC GD Tier 1 (Hindi Medium)",
    name: "Rewarded SSC GD Mock Test 2026 - 2027 (Hindi Medium)",
    description: "5 Full-Length Mock Tests",
  },
  {
    id: "1157",
    title: "SSC Selection Post",
    name: "Rewarded SSC SELECTION POST Mock Test 2026 - 2027",
    description: "5 Full-Length Mock Tests",
  },
  {
    id: "1158",
    title: "SSC CPO Tier 1",
    name: "Rewarded SSC CPO Mock Test 2026 - 2027",
    description: "5 Full-Length Mock Tests",
  },
  {
    id: "1159",
    title: "SSC Stenographer Tier 1",
    name: "Rewarded SSC STENOGRAPHER Mock Test 2026 - 2027",
    description: "5 Full-Length Mock Tests",
  },
  {
    id: "1160",
    title: "Delhi Police Constable Executive",
    name: "Rewarded DELHI POLICE CONSTABLE (EXECUTIVE) Mock Test 2026 - 2027",
    description: "5 Full-Length Mock Tests",
  },
  {
    id: "1161",
    title: "Delhi Police MTS",
    name: "Rewarded DELHI POLICE MTS Mock Test 2026 - 2027",
    description: "5 Full-Length Mock Tests",
  },
  {
    id: "1162",
    title: "Delhi Police Head Constable Ministerial",
    name: "Rewarded DELHI POLICE (HEAD CONSTABLE) Mock Test 2026 - 2027",
    description: "5 Full-Length Mock Tests",
  },
  {
    id: "1163",
    title: "RRB NTPC CBT-1 (GRADUATE LEVEL)",
    name: "Rewarded Railway NTPC CBT - 1 (GRADUATE LEVEL) Mock Test 2026 - 2027",
    description: "5 Full-Length Mock Tests",
  },
  {
    id: "1164",
    title: "RRB NTPC CBT-1 (UNDER GRADUATE )",
    name: "Rewarded Railway NTPC CBT - 1 (UNDER GRADUATE ) Mock Test 2026 - 2027",
    description: "5 Full-Length Mock Tests",
  },
  {
    id: "1165",
    title: "RRB ALP CBT - 1",
    name: "Rewarded RRB ALP CBT - 1 Mock Test 2026 - 2027",
    description: "5 Full-Length Mock Tests",
  },
    {
    id: "1166",
    title: "Railway Group - D",
    name: "Rewarded Railway Group - D Mock Test 2026 - 2027",
    description: "5 Full-Length Mock Tests",
  },
    {
    id: "1167",
    title: "RRB Technician Grade III",
    name: "Rewarded RRB Technician Grade - III Mock Test 2026 - 2027",
    description: "5 Full-Length Mock Tests",
  },
  {
    id: "1168",
    title: "RRB RPF SI",
    name: "Rewarded RRB RPF SI Mock Test 2026 - 2027",
    description: "5 Full-Length Mock Tests",
  },
  {
    id: "1169",
    title: "RRB JE",
    name: "Rewarded RRB JE Mock Test 2026 - 2027",
    description: "5 Full-Length Mock Tests",
  },
];

const PINNACLE_TEST_PORTAL_URL =
  "https://testportal.ssccglpinnacle.com/reward-tests";

  const TEST_REDIRECT_URLS = {
  1151: "https://testportal.ssccglpinnacle.com/testserieslist/1/1/1/1/ssc-eduquity-test-pass",
  1153: "https://testportal.ssccglpinnacle.com/testserieslist/1/2/3/1/ssc-eduquity-test-pass",
  1158: "https://testportal.ssccglpinnacle.com/testserieslist/1/3/5/1/ssc-eduquity-test-pass",
  1154: "https://testportal.ssccglpinnacle.com/testserieslist/1/4/4/1/ssc-eduquity-test-pass",
  1155: "https://testportal.ssccglpinnacle.com/testserieslist/1/6/7/1/ssc-eduquity-test-pass",
  1156: "https://testportal.ssccglpinnacle.com/testserieslist/1/6/7/1/ssc-eduquity-test-pass",
};

const formatPurchaseDate = (dateValue) => {
  if (!dateValue) {
    return "Not available";
  }

  const date = new Date(dateValue);

  if (Number.isNaN(date.getTime())) {
    return "Not available";
  }

  return new Intl.DateTimeFormat("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  }).format(date);
};

const getSavedReward = (storageKey) => {
  if (typeof window === "undefined") {
    return null;
  }

  try {
    const savedReward = localStorage.getItem(storageKey);

    if (!savedReward) {
      return null;
    }

    return JSON.parse(savedReward);
  } catch (error) {
    console.error(
      "Unable to read saved reward selection:",
      error
    );
    return null;
  }
};

function BookTestRewardSelector() {
  const navigate = useNavigate();
    const location = useLocation();

  const { email, barcode, source } = location.state || {};
  const [searchParams] = useSearchParams();

  const bookOrderId = searchParams.get("bookOrderId");
const [selectedTestId, setSelectedTestId] = useState("");
  const storageKey = `bookRewardSelection_${selectedTestId}`;

  const [savedReward, setSavedReward] = useState(() =>
    getSavedReward(storageKey)
  );

  
  const [activating, setActivating] = useState(false);
  const [showConfirmModal, setShowConfirmModal] =
    useState(false);

  const [error, setError] = useState("");
  const [successMessage, setSuccessMessage] =
    useState("");

  const purchaseDetails = {
    bookName:
      searchParams.get("bookName") || "Pinnacle Book",

    quantity:
      Number(searchParams.get("quantity")) || 1,

    orderId: bookOrderId || "Not available",

    purchaseDate: searchParams.get("purchaseDate"),

    paymentStatus:
      searchParams.get("paymentStatus") || "Verified",
  };

  const normalizedPaymentStatus = String(
    purchaseDetails.paymentStatus
  ).toLowerCase();

  const isVerified = [
    "verified",
    "paid",
    "completed",
    "success",
  ].includes(normalizedPaymentStatus);

  const paymentStatusText = isVerified
    ? "Verified"
    : purchaseDetails.paymentStatus;

  const selectedTest = TEST_PACKAGES.find(
    (test) => test.id === selectedTestId
  );

  const savedTest = TEST_PACKAGES.find(
    (test) => test.id === savedReward?.selectedTestId
  );

  const handleContinue = () => {
    setError("");

   if (!selectedTestId) {
  setError("Please select a Test Series.");
  return;
}

setShowConfirmModal(true);

  };

  const handleConfirmActivation = async () => {
  if (
  !selectedTestId ||
  !selectedTest ||
  activating
) {
  return;
}

  try {
    setActivating(true);
    setError("");

    // Call backend API
    await axios.put(
  `https://auth.ssccglpinnacle.com/updateStudentRewardTest/${email}`,
  {
    searchBarcode: barcode,
    rewardTest: Number(selectedTestId),
  }
);

const redirectUrl =
  TEST_REDIRECT_URLS[Number(selectedTestId)] ||
  PINNACLE_TEST_PORTAL_URL;

   const rewardSelection = {
  bookOrderId: selectedTestId, // 1151, 1153, ...
  selectedTestId,
  selectedTestPackageTitle: selectedTest.title,
  selectedTestPackageName: selectedTest.name,
  activatedAt: new Date().toISOString(),
  redirectUrl,
};

    localStorage.setItem(
      storageKey,
      JSON.stringify(rewardSelection)
    );

    setSavedReward(rewardSelection);

    setSuccessMessage(
      "Your Test Series selection has been saved successfully."
    );

    setShowConfirmModal(false);

 setTimeout(() => {
  const loginUrl =
    `https://testportal.ssccglpinnacle.com/login` +
    `?redirect=${encodeURIComponent(redirectUrl)}`;

  window.location.assign(loginUrl);
}, 1200);
  } catch (err) {
    console.error(err);

    setShowConfirmModal(false);
    setActivating(false);

    setError(
      err.response?.data?.error ||
        "Unable to save your Test Series selection."
    );
  }
};

  const PurchaseProofCard = () => (
    <div className={styles.purchaseCard}>
      <div className={styles.purchaseCardHeader}>
        <div>
          <span className={styles.purchaseLabel}>
            PURCHASE DETAILS
          </span>

          <h2 className={styles.purchaseHeading}>
            Your Book Purchase
          </h2>
        </div>

        <span
          className={`${styles.verifiedBadge} ${
            !isVerified ? styles.pendingBadge : ""
          }`}
        >
          <span className={styles.statusIcon}>
            {isVerified ? "✓" : "!"}
          </span>

          {paymentStatusText}
        </span>
      </div>

      <div className={styles.purchaseDetailsGrid}>
        <div className={styles.purchaseDetailItem}>
          <span className={styles.detailLabel}>
            Book Name
          </span>

          <strong className={styles.detailValue}>
            {purchaseDetails.bookName}
          </strong>
        </div>

        <div className={styles.purchaseDetailItem}>
          <span className={styles.detailLabel}>
            Quantity
          </span>

          <strong className={styles.detailValue}>
            {purchaseDetails.quantity}{" "}
            {purchaseDetails.quantity === 1
              ? "Book"
              : "Books"}{" "}
            Purchased
          </strong>
        </div>

        <div className={styles.purchaseDetailItem}>
          <span className={styles.detailLabel}>
            Order ID
          </span>

          <strong className={styles.detailValue}>
            {purchaseDetails.orderId}
          </strong>
        </div>

        <div className={styles.purchaseDetailItem}>
          <span className={styles.detailLabel}>
            Purchase Date
          </span>

          <strong className={styles.detailValue}>
            {formatPurchaseDate(
              purchaseDetails.purchaseDate
            )}
          </strong>
        </div>
      </div>
    </div>
  );

  if (savedReward?.selectedTestId) {
    return (
      <div className={styles.page}>
        <div className={styles.rewardCard}>
          <div className={styles.successCircle}>✓</div>

          <h1 className={styles.heading}>
            Free Tests Already Selected
          </h1>

          <PurchaseProofCard />

          {successMessage && (
            <div className={styles.successMessage}>
              {successMessage}
            </div>
          )}

          <p className={styles.description}>
            You have selected{" "}
            <strong>
              {savedReward.selectedTestPackageTitle ||
                savedTest?.title ||
                "your Test Series"}
            </strong>
            .
          </p>

          <div className={styles.warningBox}>
            This selection is final and cannot be changed
            from this page.
          </div>

          <div className={styles.buttonRow}>
            <button
              type="button"
              className={styles.primaryButton}
              onClick={() =>
                window.location.assign(
                  savedReward.redirectUrl ||
                    PINNACLE_TEST_PORTAL_URL
                )
              }
            >
              Go to Pinnacle Test Portal
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.page}>
      <div className={styles.rewardCard}>
        <div className={styles.rewardBadge}>
          PINNACLE BOOK REWARD
        </div>
<div>
      <p>Email: {email}</p>
      <p>Barcode: {barcode}</p>
      <p>Source: {source}</p>
    </div>
        <h1 className={styles.heading}>
          Select Your Free Test Series
        </h1>

        <p className={styles.description}>
          Congratulations! Your Pinnacle Book purchase
          includes <strong>5 Free Mock Tests</strong>.
        </p>

        <PurchaseProofCard />

        <p className={styles.subDescription}>
          Please select one Test Series from the options
          below.
        </p>

        <div className={styles.testList}>
          {TEST_PACKAGES.map((test) => {
            const isSelected =
              selectedTestId === test.id;

            return (
              <label
                key={test.id}
                className={`${styles.testOption} ${
                  isSelected
                    ? styles.selectedOption
                    : ""
                }`}
              >
                <input
                  type="radio"
                  name="bookRewardTest"
                  value={test.id}
                  checked={isSelected}
                  disabled={activating}
                  onChange={(event) =>
                    setSelectedTestId(event.target.value)
                  }
                  className={styles.hiddenRadio}
                />

                <span
                  className={styles.customRadio}
                ></span>

                <span
                  className={styles.testInformation}
                >
                  <span className={styles.testTitle}>
                    {test.title}
                  </span>

                  <span
                    className={styles.testDescription}
                  >
                    {test.description}
                  </span>
                </span>
              </label>
            );
          })}
        </div>

        {error && (
          <div className={styles.errorMessage}>
            {error}
          </div>
        )}

        {successMessage && (
          <div className={styles.successMessage}>
            {successMessage}
          </div>
        )}

        <div className={styles.warningBox}>
          <strong>Important:</strong> Once confirmed, your
          selected Test Series cannot be changed.
        </div>

        <div className={styles.buttonRow}>
          <button
            type="button"
            className={styles.cancelButton}
            onClick={() => navigate(-1)}
            disabled={activating}
          >
            Cancel
          </button>

          <button
            type="button"
            className={styles.primaryButton}
            onClick={handleContinue}
            disabled={!selectedTestId || activating}
          >
            Continue
          </button>
        </div>
      </div>

      {showConfirmModal && (
        <div
          className={styles.modalOverlay}
          role="dialog"
          aria-modal="true"
          aria-labelledby="confirmation-heading"
          onClick={() => {
            if (!activating) {
              setShowConfirmModal(false);
            }
          }}
        >
          <div
            className={styles.modalCard}
            onClick={(event) => event.stopPropagation()}
          >
            <h2
              id="confirmation-heading"
              className={styles.modalHeading}
            >
              Confirm Test Selection
            </h2>

            <p className={styles.modalDescription}>
              You have selected{" "}
              <strong>{selectedTest?.title}</strong>
            </p>

            <p className={styles.modalDescription}>
              Five Mock Tests from this Test Series will be
              available in your Pinnacle Test Portal.
            </p>

            <div className={styles.modalWarning}>
              Once confirmed, you will not be able to select
              another Test Series from this page.
            </div>

            <div className={styles.modalButtonRow}>
              <button
                type="button"
                className={styles.cancelButton}
                onClick={() =>
                  setShowConfirmModal(false)
                }
                disabled={activating}
              >
                Change Selection
              </button>

              <button
                type="button"
                className={styles.primaryButton}
                onClick={handleConfirmActivation}
                disabled={activating}
              >
                {activating
                  ? "Saving..."
                  : "Confirm & Continue"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default BookTestRewardSelector;

